export let messageListLabel = "hmQIxc";
export let skipToMessageList = "BiQg3c";
export default {messageListLabel,skipToMessageList};